import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
const SocialAuthContext = createContext(null);
export function SocialAuthProvider({ children }) {
    const [socialAuth, setSocialAuthState] = useState(null);
    const [registrationPrefill, setRegistrationPrefill] = useState(null);
    function setSocialAuth(state) {
        setSocialAuthState(state);
    }
    function clearSocialAuth() {
        setSocialAuthState(null);
    }
    return (_jsx(SocialAuthContext.Provider, { value: { socialAuth, setSocialAuth, clearSocialAuth, registrationPrefill, setRegistrationPrefill }, children: children }));
}
export function useSocialAuth() {
    const ctx = useContext(SocialAuthContext);
    if (!ctx) {
        throw new Error('useSocialAuth must be used within SocialAuthProvider');
    }
    return ctx;
}
